import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Restores scroll to top on every route change.
 *
 * - Skips when the URL contains a hash (#section) so in-page anchors keep working.
 * - Uses `auto` behavior (instant) to avoid jarring smooth-scroll on long pages
 *   like the Directory pagination, which was the original report.
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search, hash]);

  return null;
}
